export enum InsightsFieldsNames {
  Insights = 'insights',
}
